function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from "../../elements/Button";
import { ShowOn } from "../../layout/ShowOn";
import { CHECK_OUR_AVAILABILITY, PER_NIGHT, FROM_PRICE_PER_PERIOD } from "../../../utils/default-strings";
import { SearchBar } from "../../general-widgets/SearchBar";
import { getSummaryMarkup } from "./utils/getSummaryMarkup";
export var Component = function Component(_ref) {
  var _sharedProps;

  var dateRangePickerLocaleCode = _ref.dateRangePickerLocaleCode,
      datesInputFocusedInput = _ref.datesInputFocusedInput,
      datesInputOnFocusChange = _ref.datesInputOnFocusChange,
      datesInputValue = _ref.datesInputValue,
      getIsDayBlocked = _ref.getIsDayBlocked,
      guestsInputValue = _ref.guestsInputValue,
      isDateRangePickerLoading = _ref.isDateRangePickerLoading,
      isShowingPlaceholder = _ref.isShowingPlaceholder,
      onChangeInput = _ref.onChangeInput,
      onSubmit = _ref.onSubmit,
      searchBarDatesCheckInLabel = _ref.searchBarDatesCheckInLabel,
      searchBarDatesCheckOutLabel = _ref.searchBarDatesCheckOutLabel,
      searchBarGuestsInputLabel = _ref.searchBarGuestsInputLabel,
      searchBarMaximumGuestsInputValue = _ref.searchBarMaximumGuestsInputValue,
      searchButton = _ref.searchButton,
      summaryLocationName = _ref.summaryLocationName,
      summaryPeriodText = _ref.summaryPeriodText,
      summaryPricePerPeriod = _ref.summaryPricePerPeriod,
      summaryPricePerPeriodPrefix = _ref.summaryPricePerPeriodPrefix,
      summaryPropertyName = _ref.summaryPropertyName,
      summaryRatingNumber = _ref.summaryRatingNumber;
  var sharedProps = (_sharedProps = {
    datesCheckInLabel: searchBarDatesCheckInLabel,
    datesCheckOutLabel: searchBarDatesCheckOutLabel,
    dateRangePickerLocaleCode: dateRangePickerLocaleCode,
    datesInputFocusedInput: datesInputFocusedInput,
    datesInputOnFocusChange: datesInputOnFocusChange,
    datesInputValue: datesInputValue,
    getIsDayBlocked: getIsDayBlocked,
    guestsInputValue: guestsInputValue
  }, _defineProperty(_sharedProps, "dateRangePickerLocaleCode", dateRangePickerLocaleCode), _defineProperty(_sharedProps, "datesInputValue", datesInputValue), _defineProperty(_sharedProps, "datesInputOnFocusChange", datesInputOnFocusChange), _defineProperty(_sharedProps, "getIsDayBlocked", getIsDayBlocked), _defineProperty(_sharedProps, "guestsInputLabel", searchBarGuestsInputLabel), _defineProperty(_sharedProps, "guestsInputValue", guestsInputValue), _defineProperty(_sharedProps, "isDateRangePickerLoading", isDateRangePickerLoading), _defineProperty(_sharedProps, "isFixed", true), _defineProperty(_sharedProps, "maximumGuestsInputValue", searchBarMaximumGuestsInputValue), _defineProperty(_sharedProps, "onChangeInput", onChangeInput), _defineProperty(_sharedProps, "onSubmit", onSubmit), _defineProperty(_sharedProps, "searchButton", searchButton), _sharedProps);
  var summaryProps = {
    locationName: summaryLocationName,
    periodText: summaryPeriodText,
    pricePerPeriod: summaryPricePerPeriod,
    pricePerPeriodPrefix: summaryPricePerPeriodPrefix,
    propertyName: summaryPropertyName,
    ratingNumber: summaryRatingNumber,
    isShowingPlaceholder: isShowingPlaceholder
  };
  return React.createElement("div", {
    className: "property-page-searchbar"
  }, React.createElement(ShowOn, {
    computer: true,
    widescreen: true
  }, React.createElement(SearchBar, _extends({}, sharedProps, {
    summaryElement: getSummaryMarkup(_objectSpread({
      areOnlyNightPriceAndRatingDisplayed: false
    }, summaryProps))
  }))), React.createElement(ShowOn, {
    mobile: true,
    tablet: true
  }, React.createElement(SearchBar, _extends({}, sharedProps, {
    modalSummaryElement: getSummaryMarkup(_objectSpread({
      areOnlyNightPriceAndRatingDisplayed: false
    }, summaryProps)),
    summaryElement: getSummaryMarkup(_objectSpread({
      areOnlyNightPriceAndRatingDisplayed: true
    }, summaryProps))
  }))));
};
Component.displayName = 'PropertyPageSearchBar';
Component.defaultProps = {
  dateRangePickerLocaleCode: undefined,
  datesInputFocusedInput: undefined,
  datesInputOnFocusChange: Function.prototype,
  datesInputValue: undefined,
  getIsDayBlocked: undefined,
  guestsInputValue: undefined,
  isDateRangePickerLoading: undefined,
  isShowingPlaceholder: false,
  onChangeInput: undefined,
  onSubmit: undefined,
  searchBarDatesCheckInLabel: undefined,
  searchBarDatesCheckOutLabel: undefined,
  searchBarGuestsInputLabel: undefined,
  searchBarMaximumGuestsInputValue: undefined,
  searchButton: React.createElement(Button, {
    isFormSubmit: true,
    isPositionedRight: true,
    isRounded: true
  }, CHECK_OUR_AVAILABILITY),
  summaryPeriodText: PER_NIGHT,
  summaryPricePerPeriod: undefined,
  summaryPricePerPeriodPrefix: FROM_PRICE_PER_PERIOD,
  summaryRatingNumber: undefined
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  dateRangePickerLocaleCode: PropTypes.string,
  datesInputFocusedInput: PropTypes.oneOf([null, 'startDate', 'endDate']),
  datesInputOnFocusChange: PropTypes.func,
  datesInputValue: PropTypes.shape({
    endDate: PropTypes.object,
    startDate: PropTypes.object
  }),
  getIsDayBlocked: PropTypes.func,
  guestsInputValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  isDateRangePickerLoading: PropTypes.bool,
  isShowingPlaceholder: PropTypes.bool,
  onChangeInput: PropTypes.func,
  onSubmit: PropTypes.func,
  searchBarDatesCheckInLabel: PropTypes.string,
  searchBarDatesCheckOutLabel: PropTypes.string,
  searchBarGuestsInputLabel: PropTypes.string,
  searchBarMaximumGuestsInputValue: PropTypes.number,
  searchButton: PropTypes.node,
  summaryLocationName: PropTypes.string.isRequired,
  summaryPeriodText: PropTypes.string,
  summaryPricePerPeriod: PropTypes.string,
  summaryPricePerPeriodPrefix: PropTypes.string,
  summaryPropertyName: PropTypes.string.isRequired,
  summaryRatingNumber: PropTypes.number
} : {};